import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket, ArrowRight, Trophy } from "lucide-react";
import api from "../lib/api";

export default function LaunchDayBanner() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.launchDayStatus().then(setStatus).catch(() => {});
  }, []);

  if (!status) return null;
  if (status.completed_at) return null;  // hide once finished

  const pct = Math.round((status.done / status.total) * 100);
  const allDone = status.done === status.total;

  return (
    <div className="mb-6 border-2 border-black p-5 bg-[#FFFBEB] flex items-center gap-4 flex-wrap" data-testid="launch-day-banner">
      <div className="flex items-center gap-3 flex-1 min-w-[280px]">
        <div className="w-12 h-12 bg-black flex items-center justify-center text-white">
          {allDone ? <Trophy size={22} className="text-[#F59E0B]"/> : <Rocket size={22}/>}
        </div>
        <div className="flex-1">
          <div className="font-display font-bold text-lg leading-tight">
            {allDone ? "Launch Day complete — claim your trophy" : `Launch Day · ${status.done}/${status.total} done`}
          </div>
          <div className="text-xs text-[#52525B] mt-1">
            {allDone ? "Mark it complete to lock in the milestone." : "12 minutes to your first live Substack post. Step-by-step."}
          </div>
          {!allDone && (
            <div className="h-1.5 bg-white border border-black mt-2 overflow-hidden">
              <div className="h-full bg-[#F59E0B]" style={{ width: `${pct}%` }}/>
            </div>
          )}
        </div>
      </div>
      <button onClick={() => navigate("/launch-day")} className="bg-black text-white px-5 py-3 text-sm hover:bg-[#F59E0B] hover:text-black flex items-center gap-2" data-testid="open-launch-day-button">
        {allDone ? "Finish →" : "Continue"} <ArrowRight size={14}/>
      </button>
    </div>
  );
}
